export enum MeasurementTypeEnum {
  WEIGHT = "WEIGHT",
  VOLUME = "VOLUME",
  MEASURE = "MEASURE",
}
